import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AbilityService } from 'ability';
import { RoutingPath } from 'mbs-ui-shared@constants';
import { AuthFacade } from 'mbs-ui-shared@facades/auth.facade';
import { PermissionsEnum } from 'mbs-ui-shared@models/PermissionsEnum';
import { PremiumSupportService } from 'mbs-ui-shared@services/premium-support.service';
import { first, map } from 'rxjs/operators';

export const PremiumSupportGuard: CanActivateFn = () => {
  const authFacade = inject(AuthFacade);
  const ability = inject(AbilityService);
  const premiumSupport = inject(PremiumSupportService);
  const router = inject(Router);

  // hasPremiumSupportLicense derives from /me and reads false until it arrives, so the check cannot run on the signal alone
  return authFacade.currentUser$.pipe(
    first(Boolean),
    map(() => {
      if (premiumSupport.hasPremiumSupportLicense()) {
        return router.createUrlTree([RoutingPath.SupportPortal], { queryParams: { force: true } });
      }

      if (ability.can('read', PermissionsEnum.LicenseBuy)) premiumSupport.openBuyModal();

      return router.createUrlTree([RoutingPath.ApDashboard]);
    })
  );
};
